import styled from 'styled-components'

export const Container = styled.div`
  .collapse {
    margin-bottom: 1em;
    border: none;
    text-align: center;
  }

  .ant-collapse-header{
    color: var(--ant-primary-color);
  }

  .styled-iframe {
    width: 80%;
    height: 100%;
  }
`;
